import { AnyAction } from 'redux';

type Matchable<AC extends () => AnyAction> = AC & {
  type: ReturnType<AC>['type'];
  match(action: AnyAction): action is ReturnType<AC>;
};
// we have some type 'Matchable', its gonna take some generic 'AC' (here, Action Creator), this AC is an object or some function that returns back 'AnyAction'. Now, we want 'Matchable' to be 'AC' and we also want to intersect it against another type and this type is going to have that type value, where we get the 'ReturnType' from the 'AC', so we want to get the action itself. And from this value we want to get the 'type' from the type property which we can access using the square bracket. This will reach into the action get the type value and then take the type off of that value and set it to this type (type: inside Matchable).

// Then we have some match() method, this method receives an 'action' (here, 'AnyAction'). match() will narrow the type down, like type predicate functions. Here, once we receive action in match() we are narrowing it down to the 'ReturnType' of 'AC' (action creator).

export function withMatcher<AC extends () => AnyAction & { type: string }>(
  actionCreator: AC
): Matchable<AC>;

export function withMatcher<
  AC extends (...args: any[]) => AnyAction & { type: string }
>(actionCreator: AC): Matchable<AC>;

export function withMatcher(actionCreator: Function) {
  const type = actionCreator().type;
  return Object.assign(actionCreator, {
    type,
    match(action: AnyAction) {
      return action.type === type;
    },
  });
}

export type ActionWithPayload<T, P> = {
  type: T;
  payload: P;
};
export type Action<T> = {
  type: T;
};

export function createAction<T extends string, P>(
  type: T,
  payload: P
): ActionWithPayload<T, P>;

export function createAction<T extends string>(
  type: T,
  payload: void
): Action<T>;

export function createAction<T extends string, P>(type: T, payload: P) {
  return { type, payload };
}

// export const createAction = (type, payload) => ({ type, payload });
